module.exports = __webpack_public_path__ + "assets1733911544048/img/logo-block.b2a020b6.png";